import { createGamingModuleStore } from './gaming-module-factory'

export const useMinecraftStore = createGamingModuleStore('minecraft', 25565)
